import 'regenerator-runtime';

import React from 'react';
import { render } from 'react-dom';
import { Router, Route, Switch } from 'react-router-dom';
import {createBrowserHistory} from 'history';
import { TrackJS } from 'trackjs';
import APPCONFIG from 'constants/Config';
import Framework from '@beardeddevops/react.framework';
import App from './containers/App';
import {defaultState} from 'constants/State';

const history = createBrowserHistory();

if (!APPCONFIG.settings.isDev()) {
	TrackJS.install({
		token: "197cc3fbd1be4e3cb724189bb24d4483",
		application: "forms-karlstechnology-com",
		version: "1"
		// for more configuration options, see https://docs.trackjs.com
	});
}

render(
	<Framework.Components.RootState defaultState = {defaultState}>
		<Router history={history}>
			<Switch>

				<Route path="/" component={App} />
			</Switch>
		</Router>
	</Framework.Components.RootState>,
	document.getElementById('app-container')
);
